import React from 'react'
import Login from 'src/views/Login'

const LoginPage: React.FC = () => {
    return <Login />
}

export default LoginPage